"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgOneDateTime(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "1 0 22 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.5 10a5.5 5.5 0 110 11 5.5 5.5 0 110-11zM15 3a1 1 0 011 1h4v5H6v8h5.174c.17.721.46 1.396.849 2.001L4 19V4h4a1 1 0 012 0h4a1 1 0 011-1zm2.5 9a3.5 3.5 0 100 7 3.5 3.5 0 000-7zm.5 1v2.313l1.772.68-.358.934L17.003 16H17v-3h1zm-9-3v2H7v-2h2zm3 0v2h-2v-2h2z" })));
}
exports.default = tombacIcon_1.default('OneDateTime')(SvgOneDateTime);
//# sourceMappingURL=OneDateTime.js.map